// extracted by mini-css-extract-plugin
export var videoHero = "_bo-4";
export var videoHeroImage = "_bo-5";
export var videoHeroOverlay = "_bo-6";
export var videoHeroSubtitle = "_bo-8";
export var videoHeroText = "_bo-7";
export var videoLauncher = "_bo-0";
export var videoLauncherIcon = "_bo-1";
export var videoLauncherSubtitle = "_bo-3";
export var videoLauncherTitle = "_bo-2";
export var videoPlayer = "_bo-a";
export var videoPlayerWrap = "_bo-9";